<div class="label-dev">
    <p>Ambiente de teste {{version}}</p>
</div>
